export { a11yConfig } from "./RNA11yConfig";
